import title from '../video_assets/Ente-rockt.png'

const url =
  'https://wdradaptiv-vh.akamaihd.net/i/medp/ondemand/weltweit/fsk0/245/2459038/,2459038_35926589,2459038_35926590,2459038_35926591,2459038_35926587,2459038_35926592,2459038_35926588,.mp4.csmil/master.m3u8'

export default {
  id: '03',
  name: 'Die Beat-Station (Musik 3/5)',
  subtitle: 'Jede Figur startet und stoppt per Klick',
  image: title,
  video: url,
}
